/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {addProtocolIfAbsent, isURL} from 'common/util/url';

export const InvisibleSubmit = () => {
  return (
    <input
      //hack to allow form submits via enter button
      attrs={{type: `submit`, tabindex: -1}}
      style={{position: `absolute`, left: `-9999px`, width: `1px`, height: `1px`}}
    />
  );
};

export function renderSegmentLabel(label: string) {
  if (isURL(label)) {
    return <a attrs={{href: addProtocolIfAbsent(label), target: `_blank`, rel: `noopener noreferrer`}}>{label}</a>;
  }

  return label;
}

export function ReCaptcha({recaptchaKey}: {recaptchaKey: string}) {
  return (
    <div
      sel='.recaptcha'
      key='g-recaptcha'
      attrs={{
        id: `recaptcha`,
        class: `g-recaptcha `,
        'data-sitekey': recaptchaKey,
        'data-size': `invisible`,
        'data-error-callback': `handleRecaptchaError`,
        'data-callback': `handleRecaptchaResponse`,
      }}
    />
  );
}
